"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoginProvider = void 0;
var _openLogin = require("@ori-events/open-login");
var _react = require("react");
var _constants = require("../../constants");
var _contexts = require("../../contexts");
var _utils = require("../../utils");
var _jsxRuntime = require("react/jsx-runtime");
const LoginProvider = ({
  children
}) => {
  const doLogin = (0, _react.useCallback)(event => {
    // Ctrl or Cmd key is pressed, redirect to AD login
    if (Boolean(event?.ctrlKey) || event?.metaKey) {
      (0, _utils.goToPage)(_constants.SSO_IDENTITY_AD_LOGIN_PATH);
      return;
    }
    (0, _utils.goToPage)(_constants.SSO_IDENTITY_LOGIN_PATH);
  }, []);
  const onLogin = (0, _react.useCallback)(() => {
    doLogin();
  }, [doLogin]);
  (0, _react.useEffect)(() => {
    window.addEventListener(_openLogin.Name, onLogin);
    return () => {
      window.removeEventListener(_openLogin.Name, onLogin);
    };
  }, [onLogin]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_contexts.Provider, {
    value: (0, _react.useMemo)(() => ({
      doLogin
    }), [doLogin]),
    children: children
  });
};
exports.LoginProvider = LoginProvider;
